import { render, staticRenderFns } from "./IntersectionObserver.vue?vue&type=template&id=ae9125a2&"
import script from "./IntersectionObserver.vue?vue&type=script&lang=js&"
export * from "./IntersectionObserver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae9125a2')) {
      api.createRecord('ae9125a2', component.options)
    } else {
      api.reload('ae9125a2', component.options)
    }
    module.hot.accept("./IntersectionObserver.vue?vue&type=template&id=ae9125a2&", function () {
      api.rerender('ae9125a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/IntersectionObserver.vue"
export default component.exports